const MAX_SAFE = BigInt(Number.MAX_SAFE_INTEGER);
const MIN_SAFE = -MAX_SAFE;

export function coerceFiniteNumber(value: unknown): number | null {
  if (value === null || value === undefined) return null;

  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === "bigint") {
    if (value > MAX_SAFE || value < MIN_SAFE) return null;
    return Number(value);
  }

  if (typeof value === "string") {
    if (value.trim() === "") return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  if (typeof value === "object") {
    // eslint-disable-next-line @typescript-eslint/no-base-to-string -- Decimal/BigInt-like têm toString próprio numérico; objetos genéricos caem em NaN→null
    const n = Number(String(value));
    return Number.isFinite(n) ? n : null;
  }

  return null;
}
